/**
 * API base URL for axios, WebSockets, and absolute media links.
 *
 * - Production (paisacx.io): https://api.paisacx.io (REACT_APP_BACKEND_URL)
 * - Local npm start: empty base + setupProxy → REACT_APP_PROXY_TARGET (deploy API)
 * - Local PC API: REACT_APP_PROXY_TARGET=http://127.0.0.1:8000
 */
function stripSlash(url) {
  return (url || "").replace(/\/$/, "");
}

function isLocalhostUrl(url) {
  return /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?$/i.test(url || "");
}

/** Public API host used by https://paisacx.io (admin + blog media). */
export const CANONICAL_API_ORIGIN = "https://api.paisacx.io";

export function resolveApiBase() {
  const direct = stripSlash(process.env.REACT_APP_DIRECT_API);
  const fromEnv = stripSlash(process.env.REACT_APP_BACKEND_URL);

  if (process.env.NODE_ENV === "development") {
    if (direct) return direct;
    if (fromEnv && !isLocalhostUrl(fromEnv)) return fromEnv;
    return "";
  }

  if (typeof window !== "undefined") {
    const host = window.location.hostname;
    if (host === "paisacx.io" || host === "www.paisacx.io") {
      return fromEnv && !isLocalhostUrl(fromEnv) ? fromEnv : CANONICAL_API_ORIGIN;
    }
    if (!fromEnv || isLocalhostUrl(fromEnv)) return window.location.origin;
    return fromEnv;
  }

  if (fromEnv && !isLocalhostUrl(fromEnv)) return fromEnv;
  return CANONICAL_API_ORIGIN;
}
